<template>
  <v-dialog v-model="markDialog" max-width="700px" persistent>
    <v-card elevation="10" class="premium-card">
      <!-- Card Title -->
      <div class="header-gradient py-4 px-6">
        <div class="d-flex justify-space-between align-center">
          <div class="d-flex align-center">
            <v-avatar size="42" color="rgba(255,255,255,0.15)" class="mr-3">
              <v-icon color="white">mdi-trophy-award</v-icon>
            </v-avatar>
            <div>
              <h3 class="header-title mb-1">{{ pageDescription }}</h3>
              <p class="header-subtitle mb-0">
                Enter assessment scores for this nomination
              </p>
            </div>
          </div>
          <v-btn icon class="close-btn" @click="closePrompt">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
      </div>

      <!-- Form -->
      <v-form ref="form2" v-model="valid" lazy-validation>
        <v-card-text class="pa-6">
          <!-- Written Test Section -->
          <div class="score-section written-test mb-6">
            <div class="section-header mb-4">
              <div class="d-flex align-center">
                <div class="section-icon-wrapper mr-3">
                  <v-icon color="deep-purple darken-2" size="24"
                    >mdi-file-document-edit</v-icon
                  >
                </div>
                <h3 class="font-weight-medium text-h6">Written Assessment</h3>
              </div>
              <div class="section-divider mt-2"></div>
            </div>

            <v-row>
              <v-col cols="12" sm="6">
                <v-text-field
                  :disabled="!ElectionOfficerFlag"
                  v-model="records.WrittenMark"
                  type="number"
                  outlined
                  dense
                  label="Mark Obtained"
                  color="deep-purple accent-4"
                  class="premium-input w-100"
                  placeholder="Enter marks"
                  hide-details
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="6">
                <v-text-field
                  :disabled="!ElectionOfficerFlag"
                  v-model="records.WrittenOutOf"
                  type="number"
                  outlined
                  dense
                  label="Out Of"
                  color="deep-purple accent-4"
                  class="premium-input w-100"
                  placeholder="Maximum marks"
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>

            <v-textarea
              v-model="records.WrittenDescription"
              :disabled="!ElectionOfficerFlag"
              outlined
              rows="2"
              label="Remarks / Description"
              color="deep-purple accent-4"
              class="premium-textarea mt-3"
              placeholder="Add your comments about the written assessment"
              hide-details
            ></v-textarea>
          </div>

          <!-- Interview Section -->
          <div class="score-section interview-section">
            <div class="section-header mb-4">
              <div class="d-flex align-center">
                <div class="section-icon-wrapper interview-icon mr-3">
                  <v-icon color="green darken-1" size="24"
                    >mdi-account-voice</v-icon
                  >
                </div>
                <h3 class="font-weight-medium text-h6">Interview Assessment</h3>
              </div>
              <div class="section-divider mt-2"></div>
            </div>

            <v-row>
              <v-col cols="12" sm="6">
                <v-text-field
                  :disabled="!ElectionOfficerFlag"
                  v-model="records.InterviewMark"
                  type="number"
                  outlined
                  dense
                  label="Mark Obtained"
                  color="green darken-1"
                  class="premium-input w-100"
                  placeholder="Enter marks"
                  hide-details
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="6">
                <v-text-field
                  :disabled="!ElectionOfficerFlag"
                  v-model="records.InterviewOutOf"
                  type="number"
                  outlined
                  dense
                  label="Out Of"
                  color="green darken-1"
                  class="premium-input w-100"
                  placeholder="Maximum marks"
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>

            <v-textarea
              v-model="records.InterviewDescription"
              :disabled="!ElectionOfficerFlag"
              outlined
              rows="2"
              label="Remarks / Description"
              color="green darken-1"
              class="premium-textarea mt-3"
              placeholder="Add your comments about the interview assessment"
              hide-details
            ></v-textarea>
          </div>
        </v-card-text>

        <!-- Actions -->
        <v-divider class="mx-4"></v-divider>
        <v-card-actions class="px-6 py-4">
          <div class="score-summary caption">
            <span class="mr-4">
              <span class="font-weight-medium text-uppercase deep-purple--text"
                >Written:</span
              >
              <span class="ml-1"
                >{{ records.WrittenMark || 0 }}/{{
                  records.WrittenOutOf || 0
                }}</span
              >
            </span>
            <span>
              <span
                class="font-weight-medium text-uppercase green--text text--darken-1"
                >Interview:</span
              >
              <span class="ml-1"
                >{{ records.InterviewMark || 0 }}/{{
                  records.InterviewOutOf || 0
                }}</span
              >
            </span>
          </div>
          <v-spacer></v-spacer>

          <v-btn
            color="grey darken-1"
            text
            class="px-4 mr-2 action-btn cancel-btn"
            @click="closePrompt"
          >
            <v-icon left size="18">mdi-close-circle</v-icon>
            Cancel
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";

export default {
  mixins: [common],
  props: {
    showDialog: {
      type: Boolean,
      required: true,
    },
    row: {
      required: true,
    },
    pageDescription: {
      type: String,
    },
  },
  data() {
    return {
      markDialog: this.showDialog,
      valid: true,
      ElectionOfficerFlag: false,
      records: {},
      submitLoading: false,
      cancelLoading: false,
    };
  },
  watch: {
    showDialog(val) {
      this.markDialog = val;
      if (val) this.refreshPageData();
    },
    markDialog(val) {
      if (!val) this.$emit("hideDialog");
    },
  },
  methods: {
    closePrompt() {
      this.markDialog = false;
    },
    refreshPageData() {
      this.getScoreRecords();
    },
    getScoreRecords() {
      const tr = this.row;
      const id = tr.NominationId;
      const server_url = companyConfig.apiURL;
      const token = this.$session.get("token") || 0;
      const add_url = `${server_url}api/nomination/score-show`;

      const upload = { UserInterface: 1, Nomination: id };
      const thisIns = this;
      var output = "";
      var records = "";
      var flag = 0;

      this.$http({
        url: add_url,
        method: "POST",
        data: upload,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      })
        .then(function (response) {
          output = response.data.output;
          flag = response.data.flag;
          console.log("output=" + output + ", flag=" + flag);

          records = response.data.records;
          console.log({ records });
          if (flag == 1) {
            thisIns.records = response.data.records;
            thisIns.sweetAlert("success", output, true);
          } else {
            thisIns.sweetAlert("error", output, false);
          }
        })
        .catch(function (error) {
          console.error("Error:", error);
        });
    },
    async submitForm() {
      // Guard: only election officers can submit
      if (!this.ElectionOfficerFlag) return;
      try {
        this.submitLoading = true;
        const server_url = companyConfig.apiURL;
        const token = this.$session.get("token") || 0;
        const add_url = `${server_url}api/nomination/score-update`;
        const upload = {
          UserInterface: 2,
          Nomination: this.row.NominationId,
          Records: this.records,
        };

        const response = await this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        });

        const output = response.data.output;
        const flag = response.data.flag;
        if (flag == 1) {
          this.sweetAlert("success", output, true);
          // notify parent to refresh and close dialog
          this.$emit("hideDialog", true);
          this.markDialog = false;
        } else {
          this.sweetAlert("error", output, false);
        }
      } catch (err) {
        console.error(err);
        this.sweetAlert("error", "Failed to submit, try again", false);
      } finally {
        this.submitLoading = false;
      }
    },
  },
  mounted() {
    this.refreshPageData();
    const roleId = this.$session.get("RoleId") || "";
    this.RoleId = roleId;

    const ElectionOfficerFlag = this.$session.get("ElectionOfficerFlag") || "";
    this.ElectionOfficerFlag = ElectionOfficerFlag;
  },
};
</script>

<style scoped>
/* Visual polish for NominationScoreShow */
.premium-card {
  border-radius: 12px;
  overflow: hidden;
}
.header-gradient {
  background: linear-gradient(90deg, rgba(106,17,203,0.95), rgba(37,117,252,0.95));
  color: #fff;
}
.header-title {
  margin: 0;
  color: #fff;
  font-weight: 700;
}
.header-subtitle {
  opacity: 0.9;
  font-size: 0.85rem;
}
.premium-input .v-input__control input:focus {
  box-shadow: 0 6px 16px rgba(105,72,252,0.08);
}
.premium-textarea {
  transition: box-shadow 180ms ease, transform 180ms ease;
}
.premium-input, .premium-textarea {
  width: 100%;
}
.score-section {
  transition: transform 300ms cubic-bezier(.2,.8,.2,1), opacity 300ms ease;
}
.score-section:hover {
  transform: translateY(-4px);
}
.action-btn {
  transition: transform 160ms ease, box-shadow 160ms ease;
}
.action-btn:hover:not(:disabled) {
  transform: translateY(-3px);
  box-shadow: 0 10px 30px rgba(0,0,0,0.12);
}
.submit-btn {
  min-width: 120px;
}
.cancel-btn {
  min-width: 100px;
}
</style>
